import { useCallback, useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { GroupTypeBase, Styles } from 'react-select';

import { IEditAllocationFormValues } from '~/ui/pages/ActTeam/reusable/ClientAllocationForm/shared/model/types';
import { IOption } from '~/types';
import { getAllSelectedClientIds } from '../utils';

import variables from '~/ui/assets/styles/colors.module.scss';

interface UseSelectAdditionalStyles {
  additionalStyleHandler: () => Partial<Styles<IOption, boolean, GroupTypeBase<IOption>>>;
}

const useSelectAdditionalStyles = (teamMemberIdx: number): UseSelectAdditionalStyles => {
  const SELECT_FIELD_NAME = `teamMembersAllocations.${teamMemberIdx}.selectedClientsIds` as const;

  const { watch } = useFormContext<IEditAllocationFormValues>();
  const selectedClientsIds = watch(SELECT_FIELD_NAME);
  const teamMembersAllocations = watch('teamMembersAllocations');

  const allSelectedClientIds = useMemo(
    () => new Set([...getAllSelectedClientIds(teamMembersAllocations), ...selectedClientsIds]),
    [teamMembersAllocations, selectedClientsIds],
  );

  const additionalStyleHandler = useCallback(
    () => ({
      option: (provided: Record<string, unknown>, { data }: { data: { value: number } }) => ({
        ...provided,
        backgroundColor: !allSelectedClientIds.has(data?.value) ? '#FFF1EE' : 'inherit',
        fontWeight: '300',
        color: variables.colorBlack,
      }),
    }),
    [allSelectedClientIds],
  );

  return {
    additionalStyleHandler,
  };
};

export default useSelectAdditionalStyles;
